module.exports = __webpack_public_path__ + "static/media/rp3-racing-logo-square.0f39a443.svg";